var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestrail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 110 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #65c179;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logos"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 91.48,
    y: 27.04,
    width: 4.96,
    height: 4.96,
    rx: 0.38,
    ry: 0.38,
    transform: "translate(6.64 75.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 96.29,
    y: 22.24,
    width: 4.96,
    height: 4.96,
    rx: 0.38,
    ry: 0.38,
    transform: "translate(11.45 77.08) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 101.1,
    y: 17.43,
    width: 4.96,
    height: 4.96,
    rx: 0.38,
    ry: 0.38,
    transform: "translate(16.26 79.07) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 91.57,
    y: 17.52,
    width: 4.96,
    height: 4.96,
    rx: 0.38,
    ry: 0.38,
    transform: "translate(13.41 72.36) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 96.38,
    y: 12.71,
    width: 4.96,
    height: 4.96,
    rx: 0.38,
    ry: 0.38,
    transform: "translate(18.21 74.36) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 91.66,
    y: 7.99,
    width: 4.96,
    height: 4.96,
    rx: 0.38,
    ry: 0.38,
    transform: "translate(20.17 69.64) rotate(-45)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m12.48,13.38v15.89h-3.36v-15.89H3.07v-2.94h15.47v2.94h-6.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.31,22.4c0-4.04,2.73-7.16,6.56-7.16s6.11,3.02,6.11,6.79v1.05h-9.65c.24,2.36,1.65,3.8,3.67,3.8,1.55,0,2.78-.79,3.2-2.2l2.7,1.02c-.97,2.41-3.15,3.85-5.9,3.85-3.93,0-6.69-2.91-6.69-7.16Zm3.17-1.68h6.32c-.03-1.52-.97-2.83-2.96-2.83-1.63,0-2.88.97-3.36,2.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.46,24.76c.81,1.34,2.39,2.23,3.99,2.23,1.34,0,2.57-.47,2.57-1.7s-1.15-1.31-3.33-1.76-4.67-1-4.67-3.93c0-2.52,2.2-4.35,5.38-4.35,2.41,0,4.56,1.08,5.56,2.6l-2.12,1.91c-.79-1.23-2.1-1.94-3.62-1.94-1.28,0-2.12.58-2.12,1.49,0,1,1,1.18,2.73,1.55,2.33.5,5.27,1,5.27,4.14,0,2.78-2.54,4.56-5.66,4.56-2.54,0-5.09-1.02-6.32-2.91,0,0,2.36-1.89,2.36-1.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.13,18.18h-1.91v-2.67h1.91v-4.04h3.09v4.04h2.88v2.67h-2.88v7.13c0,1.23.71,1.36,1.84,1.36.52,0,.81-.03,1.28-.08v2.65c-.58.1-1.36.18-2.18.18-2.62,0-4.04-.81-4.04-3.62v-7.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52,29.27h-3.36V10.44h7.53c4.2,0,6.82,1.97,6.82,5.77,0,2.96-1.63,4.85-4.38,5.51l4.85,7.55h-3.83l-4.59-7.29h-3.04s0,7.29,0,7.29Zm3.99-10.17c2.41,0,3.7-1.05,3.7-2.88s-1.28-2.88-3.7-2.88h-3.99v5.77h3.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.39,25.44c0-2.62,1.97-3.78,4.61-4.33l3.8-.79v-.24c0-1.31-.68-2.12-2.36-2.12-1.49,0-2.28.68-2.65,2.02l-2.96-.68c.68-2.28,2.7-4.06,5.74-4.06,3.3,0,5.3,1.57,5.3,4.75v5.93c0,.79.34,1.02,1.21.92v2.44c-2.28.26-3.49-.18-3.96-1.31-.87.97-2.31,1.55-4.09,1.55-2.62,0-4.64-1.6-4.64-4.06h0Zm8.42-2.7l-2.96.63c-1.34.29-2.33.71-2.33,1.94,0,1.08.79,1.68,1.99,1.68,1.68,0,3.3-.89,3.3-2.57v-1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80.35,29.27h-3.15v-13.77h3.15v13.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.58,29.27h-3.15V10.44h3.15v18.83Z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 77.15,
    y: 10.44,
    width: 3.25,
    height: 3.23
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestrail);
export default __webpack_public_path__ + "static/media/testrail.2b5c5eb34b02aedf053610aaebdc306b.svg";
export { ForwardRef as ReactComponent };